export interface PayinPaymentSwitchingResponse {
    paymentDirectionActivitySettings: PayinPaymentSwitchingResponseItem[];
}

export interface PayinPaymentSwitchingResponseItem {
    code: string;
    value: 'true' | 'false';
}

export enum PayinPaymentSwitchingResponseCodes {
    PayinActive = 'account_settings.trader_settings.direction_activity_settings.payin_active',
    PayoutActive = 'account_settings.trader_settings.direction_activity_settings.payout_active'
}
